module.exports = __webpack_public_path__ + "images/jitta.png?42983fe9494a8d683623f4fb4c113ffe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jitta.png
// module id = 49
// module chunks = 0